export const instanceMembersApiEndpoint =
  '/tables/spanning-tree/instance-members';
